<script setup>
import EntityHistoryView from "@/shared/ui/history/EntityHistoryView.vue";

defineProps({
  selectedItem: {
    type: Object,
    default: () => null,
  },
});
</script>

<template>
  <EntityHistoryView entity-type="directory" :entity-id="selectedItem?.code" />
</template>
